import { render, staticRenderFns } from "./IconMenuAlt1Outline.vue?vue&type=template&id=152cb8ea"
import script from "./IconMenuAlt1Outline.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt1Outline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports